export default __webpack_public_path__ + "static/NeighborhoodDesignCodesAndOrdinances-6859dd511e8cd73aea1f713fa9560f58.jpg";